import React from 'react'

export default function TwoDoors({ className }) {
    return (
        <svg 
            className={`w-8 h-6 ${className}`}
            aria-hidden="true"
            fill="#23428b" 
            viewBox="0 0 32 32" 
            xmlns="http://www.w3.org/2000/svg" 
            version="1.1" 
            id="door" 
            enableBackground="new 0 0 32 32" 
            stroke="#23428b">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier"> 
                    <rect x="21" y="15" width="2" height="2"></rect> 
                    <path d="M27 29V1H5v28H3v2h26v-2H27zM7 29V3h18v26H7z"></path>
                </g>
        </svg>

    )
}
{/* <svg 
   fill="#23428b" 
   viewBox="0 0 32 32" 
   xmlns="http://www.w3.org/2000/svg" 
   xmlns:xlink="http://www.w3.org/1999/xlink" 
   version="1.1" 
   id="door" 
   enableBackground="new 0 0 32 32" 
   xml:space="preserve" 
   stroke="#23428b">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier"> 
        <rect x="21" y="15" width="2" height="2"></rect> 
        <path d="M27 29V1H5v28H3v2h26v-2H27zM7 29V3h18v26H7z"></path>
    </g>
</svg> */}